import { GridsterItem } from "angular-gridster2";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GridsterService {
  defaultDash = [
    {
      cols: 14,
      rows: 7,
      y: 0,
      x: 0,
      dragEnabled: true,
      resizeEnabled: true,
      name: "market-watch",
      state: "Most Active",
    },
    {
      cols: 8,
      rows: 7,
      y: 0,
      x: 22,
      dragEnabled: true,
      resizeEnabled: true,
      name: "market-news",
    },
    {
      cols: 8,
      rows: 7,
      y: 0,
      x: 14,
      dragEnabled: true,
      resizeEnabled: true,
      name: "market-trades",
    },
    {
      cols: 15,
      rows: 6,
      x: 0,
      y: 7,
      dragEnabled: true,
      resizeEnabled: true,
      name: "order-book",
    },
    {
      cols: 7,
      rows: 6,
      x: 15,
      y: 7,
      dragEnabled: true,
      resizeEnabled: true,
      name: "market-depth",
      isLinked: true,
    },
    {
      cols: 8,
      rows: 6,
      x: 22,
      y: 7,
      dragEnabled: true,
      resizeEnabled: true,
      name: "historical",
    },
    {
      cols: 6,
      rows: 6,
      y: 13,
      x: 6,
      dragEnabled: true,
      resizeEnabled: true,
      name: "depth-asks",
    },
    {
      cols: 6,
      rows: 6,
      y: 13,
      x: 0,
      dragEnabled: true,
      resizeEnabled: true,
      name: "depth-bids",
    },
    {
      cols: 9,
      rows: 6,
      y: 13,
      x: 12,
      dragEnabled: true,
      resizeEnabled: true,
      name: "news",
    },
  ];

  isDarkTheme: boolean;

  constructor() {
    this.initTheme();
  }

  private newGenericWidget = new Subject<any>();

  addGeneric(name) {
    let item;
    if (name == "market-watch")
      item = {
        cols: 6,
        rows: 5,
        x: 2,
        y: 2,
        dragEnabled: true,
        resizeEnabled: true,
        name: name,
        state: "Most Active",
      };
    else if (name == "chart")
      item = {
        cols: 10,
        rows: 6,
        x: 2,
        y: 2,
        dragEnabled: true,
        resizeEnabled: true,
        name: name,
        isLinked: true,
      };
    else
      item = {
        cols: 6,
        rows: 5,
        x: 2,
        y: 2,
        dragEnabled: true,
        resizeEnabled: true,
        name: name,
        isLinked: true,
      };

    this.newGenericWidget.next(item);
  }

  saveGrid(newDashboard) {
    localStorage.setItem("dashboard", JSON.stringify(newDashboard));
  }

  updateGridWithIndex(index, newDashboard) {
    let tempDashboard = this.getGrid();
    tempDashboard[index] = newDashboard;
    localStorage.setItem("dashboard", JSON.stringify(tempDashboard));
  }

  resetGridWithIndex(index, newDashboard) {
    let tempDashboard = this.getGrid();
    tempDashboard[index] = newDashboard;
    localStorage.setItem("dashboard", JSON.stringify(tempDashboard));
  }

  onNewGenericAdded(): Observable<any> {
    return this.newGenericWidget.asObservable();
  }

  getGrid() {
    return JSON.parse(localStorage.getItem("dashboard"));
  }

  addNewDashboard() {
    let tempDashboard: Array<GridsterItem>[] = this.getGrid();
    tempDashboard.push(this.defaultDash);
    localStorage.setItem("dashboard", JSON.stringify(tempDashboard));
    return tempDashboard.length;
  }
  removeDashboard(index) {
    let tempDashboard: Array<GridsterItem>[] = this.getGrid();
    tempDashboard.splice(index, 1);
    localStorage.setItem("dashboard", JSON.stringify(tempDashboard));
    return tempDashboard.length;
  }

  saveLang(language) {
    localStorage.setItem("lang", language);
  }

  getLang() {
    return localStorage.getItem("lang");
  }

  saveMarketWatchColumns(newColsList) {
    localStorage.setItem("marketCols", JSON.stringify(newColsList));
  }

  saveTradesColumns(newColsList) {
    localStorage.setItem("tradesCols", JSON.stringify(newColsList));
  }

  saveFavoritesView(value) {
    localStorage.setItem("favView", value);
  }

  getFavoritesView() {
    return localStorage.getItem("favView");
  }

  getMarketWatchColumns() {
    return JSON.parse(localStorage.getItem("marketCols"));
  }

  getTradesColumns() {
    return JSON.parse(localStorage.getItem("tradesCols"));
  }

  updateMarketWatchState(id: any, newState) {
    let dashboard = this.getGrid();
    if (dashboard) {
      if (dashboard[id]) {
        dashboard[id][id].state = newState;
        this.saveGrid(dashboard);
      }
    }
  }

  getMarketWatchState(id: any) {
    let dashboard = this.getGrid();
    let state = dashboard[id].state;
    return state;
  }

  resetGrid() {
    localStorage.setItem("dashboard", JSON.stringify(this.defaultDash));
    localStorage.setItem("portfolioCols", JSON.stringify(""));
  }
  savePortfolioColumns(newColsList) {
    localStorage.setItem("portfolioCols", JSON.stringify(newColsList));
  }
 getPortfolioColumns() {
    return JSON.parse(localStorage.getItem("portfolioCols"));
  }
  /////////////
  saveOrderHistoryColumns(newColsList) {
    localStorage.setItem("orderHistoryCols", JSON.stringify(newColsList));
  }

  getOrderHistoryColumns() {
    return JSON.parse(localStorage.getItem("orderHistoryCols"));
  }
  //////////////
  saveTradeHistoryColumns(newColsList) {
    localStorage.setItem("tradeHistoryCols", JSON.stringify(newColsList));
  }

  getTradeHistoryColumns() {
    return JSON.parse(localStorage.getItem("tradeHistoryCols"));
  }

  switchTheme() {
    this.isDarkTheme = !this.isDarkTheme;
  }

  initTheme() {
    this.isDarkTheme = localStorage.getItem("darktheme") == "light" ? false : true;
    localStorage.setItem("darktheme", this.isDarkTheme ? "dark" : "light");
    document.body.setAttribute(
      "data-theme",
      this.isDarkTheme ? "dark" : "light"
    );
  }
}
